import React from 'react'
import {
  Button, TagItem,
} from '../../../components'
import Select from 'react-select'
import { useViewport, viewportBreakpoint } from '../../../utils'

const ContentOfficialFeatured = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <form>
      <div>
        <p className="text-lg font-bold mb-5">Featured Programs</p>
        <div className="w-full lg:w-1/2 flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full mr-4 lg:mr-2" options={[]} placeholder="Search Program" />
          <Button
            style={{maxWidth: isMobile ? '25%' : '137px'}}
            thin
            className="w-full lg:w-auto h-full px-4"
          >
            Add
          </Button>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <TagItem value="Frosh by Peacegen"/>
          </div>
          <div className="mb-4 lg:mb-2">
            <TagItem value="Boargame Damai"/>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/3">
        <hr className="mt-6 mb-8 lg:mt-10 lg:mb-10" />
      </div>
      <div>
        <p className="text-lg font-bold mb-5">Featured Events</p>
        <div className="w-full lg:w-1/2 flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full mr-4 lg:mr-2" options={[]} placeholder="Search Event" />
          <Button
            style={{maxWidth: isMobile ? '25%' : '137px'}}
            thin
            className="w-full lg:w-auto h-full px-4"
          >
            Add
          </Button>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <TagItem value="Buku Panduan Perdamaian"/>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/3">
        <hr className="mt-6 mb-8 lg:mt-10 lg:mb-10" />
      </div>
      <div>
        <p className="text-lg font-bold mb-5">Featured Resources</p>
        <div className="w-full lg:w-1/2 flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full mr-4 lg:mr-2" options={[]} placeholder="Search Resource" />
          <Button
            style={{maxWidth: isMobile ? '25%' : '137px'}}
            thin
            className="w-full lg:w-auto h-full px-4"
          >
            Add
          </Button>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <TagItem value="Buku Panduan Perdamaian"/>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/3">
        <hr className="mt-6 mb-8 lg:mt-10 lg:mb-10" />
      </div>
      <div className="mb-8">
        <p className="text-lg font-bold mb-5">Featured Blog</p>
        <div className="w-full lg:w-1/2 flex flex-row items-center mb-4 lg:mb-5">
          <Select className="text-sm w-full mr-4 lg:mr-2" options={[]} placeholder="Search Blog" />
          <Button
            style={{maxWidth: isMobile ? '25%' : '137px'}}
            thin
            className="w-full lg:w-auto h-full px-4"
          >
            Add
          </Button>
        </div>
        <div className="flex flex-wrap">
          <div className="mr-4 lg:mr-2 mb-4 lg:mb-2">
            <TagItem value="Buku Panduan Perdamaian"/>
          </div>
        </div>
      </div>
    </form>
  )
}

export { ContentOfficialFeatured }